class CompareDialog extends HTMLDialogElement {
  constructor() {
    super();

    this.openButton = document.querySelector(`[data-compare-open="${ this.dataset.compareModal}"]`);
    this.closeButton = this.querySelector('[data-compare-close]');
    
    this.compareSwiperEl = this.querySelector('.swiper');
    this.compareSwiperPrevEl = this.querySelector('.swiper-container .swiper-button-prev__custom');
    this.compareSwiperNextEl = this.querySelector('.swiper-container .swiper-button-next__custom');

    this.compareSwiperSlideLength = this.querySelectorAll('.swiper-slide').length;
    console.log("🚀 ~ file: compare-dialog.js:13 ~ CompareDialog ~ constructor ~ this.compareSwiperSlideLength:", this.compareSwiperSlideLength);

    this.openButton.addEventListener('click', e => {
      this.showModal();
    });
    
    this.closeButton.addEventListener('click', e => {
      this.close();
    });

    this.addEventListener('click', e => {
      const dialogDimensions = this.getBoundingClientRect()
      if (
        e.clientX < dialogDimensions.left ||
        e.clientX > dialogDimensions.right ||
        e.clientY < dialogDimensions.top ||
        e.clientY > dialogDimensions.bottom
      ) {
        this.close()
      }
    });

    if (document.body.hasAttribute("swiper-loaded")) {
      this.initSlider();
    } else {
      document.addEventListener('swiper-loaded', (event) => {
        this.initSlider();
      });
    }
  }

  initSlider() {
    this.compareSwiper = new Swiper(this.compareSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        prevEl: this.compareSwiperPrevEl,
        nextEl: this.compareSwiperNextEl
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 17,
        },
        1085: {
          slidesPerView: 4,
          spaceBetween: 17,
        },
      }
    });
  }
}

customElements.define('compare-dialog', CompareDialog, {extends: 'dialog'});